import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect, useState, useContext } from "react";
import { ConfigContext } from "./ConfigContext";
import { SecurityContext } from "./WrappedSecurity";

interface MyContext {
  [name: string]: any;
}
export const CurrentUserContext = React.createContext<[MyContext | null]>([null]);
export const CurrentUserProvider = (props) => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [config] = useContext(ConfigContext);
  const [isSecurityLoaded] = useContext(SecurityContext);

  useEffect(() => {
    if (authState && isSecurityLoaded && authState.isAuthenticated && !Boolean(userInfo)) {
      // Make userInfo and job-definitions calls in parallel
      oktaAuth.getUser().then((info) => {
        let response = {...info};
        // Below condition is to take care of the OKTA backend issue
        // where they have samAccountName for production and sAMAccountName for other environments
        if (config && config.app && config.app.environment === "prod") {
          response.sAMAccountName = response.samAccountName;
          delete response.samAccountName;
        }
        setUserInfo(response);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState, setUserInfo, config]);

  return <CurrentUserContext.Provider value={[userInfo]}>{props.children}</CurrentUserContext.Provider>;
};
